import { RoomConfigurationType } from '@/features/room-config'
import { getUuid } from '@/utils/getUuid'

import { RoomConfigurationSlice, SliceState } from './types'

export const createRoomConfigurationSlice: SliceState<RoomConfigurationSlice> = (set) => ({
	roomConfigurations: [],
	setRoomConfigurations: (roomConfigurations: Omit<RoomConfigurationType, 'id'>[]) =>
		set(
			(state) => ({
				...state,
				roomConfigurations: roomConfigurations.map((room) => ({ ...room, id: getUuid() })),
			}),
			false,
			'setRoomConfigurations'
		),
	addRoomConfiguration: () =>
		set(
			(state) => {
				return {
					...state,
					roomConfigurations: [
						...state.roomConfigurations,
						{
							id: getUuid(),
							adults: 2,
							children: [],
							isValid: true,
						},
					],
				}
			},
			false,
			'addRoomConfiguration'
		),
	removeRoomConfiguration: (id: string) =>
		set(
			(state) => {
				return {
					...state,
					roomConfigurations: state.roomConfigurations.filter((room) => room.id !== id),
				}
			},
			false,
			'removeRoomConfiguration'
		),
	updateRoomConfiguration: (roomConfiguration: RoomConfigurationType) =>
		set(
			(state) => ({
				...state,
				roomConfigurations: state.roomConfigurations.map((room) =>
					room.id === roomConfiguration.id ? roomConfiguration : room
				),
			}),
			false,
			'updateRoomConfiguration'
		),
})
